export default () => {
  return {
    sidebarOpen: false,
  }
}
